export type SessionExpirationDependencies = {
  getCurrentPath: () => string;
  clearClientSession: () => void;
  revokeServerSession: () => Promise<unknown>;
  replaceLocation: (path: string) => void;
};

const PUBLIC_AUTH_PATHS = new Set(["/login", "/activate-account"]);

export function createSessionExpirationHandler(
  dependencies: SessionExpirationDependencies,
) {
  let handlingExpiration = false;

  return () => {
    if (
      handlingExpiration ||
      PUBLIC_AUTH_PATHS.has(dependencies.getCurrentPath())
    ) {
      return;
    }

    handlingExpiration = true;
    dependencies.clearClientSession();
    void dependencies.revokeServerSession().catch(() => {
      // The API has already rejected the session. Local logout and redirect
      // remain authoritative even if the best-effort server revocation fails.
    });
    dependencies.replaceLocation("/login?reason=session-expired");
  };
}
